import React from 'react';
import { BiError } from 'react-icons/bi';
import styles from './Page404.module.scss';

const Page404 = () => (
  <div className={styles.container}>
    <BiError size="3rem" />
    <div className={styles.text}>404 page not found</div>
  </div>
);

export default Page404;
